<!--表格组件 -->
<template>
  <section class="ces-table-page">
    <!-- 表格操作按钮 -->
    <!-- 数据表格 -->
    <section class="ces-table">
      <el-table
        :data="tableData"
        :size="size"
        :max-height="maxHeight"
        :border="isBorder"
        @select="select"
        @selection-change="selectionChange"
        @select-all="selectAll"
        v-loading="loading"
        @sort-change="changeSort"
        @row-dblclick="
          (row, column, event) => {
            rowDblClick(row, column, event, editList);
          }
        "
        fit
        style="width:100%"
        ref="cesTable"
        :header-cell-style="{
          'background-color': '#007AE1',
          height: '45px',
          color: '#fff'
        }"
        :row-class-name="rowClassName"
        :cell-class-name="rowClass"
        :span-method="spanMethod"
        :show-summary="summary"
        :summary-method="getSummaries"
      >
        <el-table-column
          v-if="isSelection"
          type="selection"
          :selectable="selectEnable"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="isIndex"
          type="index"
          :label="indexLabel"
          align="center"
          :index="indexMethod"
          width="50"
        ></el-table-column>
        <!-- 数据栏 -->
        <el-table-column
          v-for="item in tableCols"
          :key="item.id"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :fixed="item.type == 'Button' ? 'right' : null"
          :render-header="item.require ? renderHeader : null"
          :sortable="item.sortable"
        >
          >
          <template slot-scope="scope">
            <!-- 按钮 -->
            <span v-if="item.type === 'Button'">
              <span
                class="operation"
                :class="
                  scope.row.rank == '1' && btn.show == 'WorkNo'
                    ? 'btnGrey'
                    : btn.itemClass
                "
                v-for="(btn, index) in item.btnList"
                :key="index"
                @click="
                  scope.row.rank == '1' && btn.show == 'WorkNo'
                    ? null
                    : btn.handle(scope.row, scope.$index)
                "
                v-auth="btn.auth"
              >
                <span v-show="btn.isshow != 'true'">
                  {{
                    (btn.formatter &&
                      btn.formatter(
                        scope.row,
                        btn.prop,
                        scope.row[btn.prop]
                      )) ||
                      btn.label
                  }}
                </span>
              </span>
            </span>

            <div v-else>
              <!-- 编辑 -->
              <div class="edit-input" v-if="item.isEdit">
                <el-input-number
                  :precision="3"
                  :step="0.1"
                  :max="10"
                  v-model="tableData[scope.$index][item.prop]"
                  placeholder="值"
                  style="width: 100%"
                  @blur="blurEdit($event)"
                  size="small"
                ></el-input-number>
              </div>
              <div class="edit-input" v-if="item.editNo">
                <!-- <el-input-number
                  :precision="3"
                  :step="0.1"
                  :max="10"
                  v-model="tableData[scope.$index][item.prop]"
                  placeholder="值"
                  style="width: 100%"
                  @blur="blurEdit($event)"
                  size="small"
                ></el-input-number> -->
                <el-input
                  v-model="tableData[scope.$index][item.prop]"
                  placeholder="值"
                ></el-input>
              </div>
              <el-popover
                trigger="hover"
                placement="top"
                v-if="item.type == 'phone'"
              >
                <p>联系方式: {{ scope.row[item.type] }}</p>
                <div slot="reference" class="name-wrapper">
                  <span class="read">{{
                    (item.formatter &&
                      item.formatter(
                        scope.row,
                        item.prop,
                        scope.row[item.prop]
                      )) ||
                      scope.row[item.prop] ||
                      "--"
                  }}</span>
                </div>
              </el-popover>
              <!-- 图片：缩略图展示，点击弹出大图预览 -->
              <el-image
                v-else-if="item.type === 'image'"
                class="table-image"
                fit="cover"
                :src="
                  (item.formatter &&
                    item.formatter(
                      scope.row,
                      item.prop,
                      scope.row[item.prop],
                      scope.$index
                    )) ||
                  scope.row[item.prop]
                "
                :preview-src-list="[
                  (item.formatter &&
                    item.formatter(
                      scope.row,
                      item.prop,
                      scope.row[item.prop],
                      scope.$index
                    )) ||
                    scope.row[item.prop]
                ]"
              ></el-image>
              <span class="read" v-else>{{
                (item.formatter &&
                  item.formatter(
                    scope.row,
                    item.prop,
                    scope.row[item.prop],
                    scope.$index
                  )) ||
                  scope.row[item.prop] ||
                  "--"
              }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 分页 -->
    <section class="ces-pagination" v-if="isPagination">
      <el-pagination
        background
        style="display: flex;justify-content: center;height: 100%;align-items: center;"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes,prev, pager, next"
        :total="pagination.total"
        :current-page="pagination.page"
        :page-sizes="[10, 50, 100, 500, 1000, 2000]"
      ></el-pagination>
    </section>
  </section>
</template>

<script>
var elementResizeDetectorMaker = require("element-resize-detector");
import { addClass, removeClass } from "../../utils";
export default {
  name: "tablePage",
  props: {
    // 表格型号：mini,medium,small
    size: { type: String, default: "medium" },
    isBorder: { type: Boolean, default: true },
    summary: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    // 表格操作
    isHandle: { type: Boolean, default: false },
    // 表格数据
    tableData: { type: Array, default: () => [] },
    getSummaries: { type: Function, default: () => {} },
    // 表格列配置
    tableCols: { type: Array, default: () => [] },
    // 是否显示表格复选框
    isSelection: { type: Boolean, default: false },
    // 是否显示表格索引
    isIndex: { type: Boolean, default: false },
    indexLabel: { type: String, default: "序号" },
    // 是否显示分页
    isPagination: { type: Boolean, default: true },

    // 分页数据
    pagination: {
      type: Object
    },

    // 可行内编辑字段
    editList: {
      type: Array,
      default: () => []
    },
    // 表格的className
    rowClassName: {
      type: String,
      default: ""
    },
    // 单元格的样式
    rowClass: {
      type: Function,
      default: () => {}
    },
    // 合并行列方法
    spanMethod: {
      // type: Function,
      default: () => {}
    },
    // 多选禁用
    selectEnable: {
      type: Function,
      default: () => {}
    },

    // 多选清空
    clearSelection: {
      type: Boolean,
      default: false
    },
    indexMethod: {
      type: Function,
      default: index => {
        return index + 1;
      }
    },
    data: { type: Object }
  },
  data() {
    return {
      maxHeight: 0,
      allCheck: false
    };
  },
  watch: {
    clearSelection(a, b) {
      console.log(b);
      if (b) {
        this.$refs.cesTable.clearSelection();
      }
    }
  },

  methods: {
    blurEdit(event) {
      console.log(event);
      event.path.forEach((v, i) => {
        if (v.className && v.className.indexOf("edit-col") != "-1") {
          removeClass(event.path[i], "edit-col");
        }
      });
    },
    //行点击
    rowDblClick(row, column, event, editList) {
      console.log(row, column, event, editList);
      console.log("object", editList, column.property);
      if (editList.indexOf(column.property) != "-1") {
        console.log(" bject2", event.target);
        addClass(event.target, "edit-col");
        console.log("object1", event.target);
      }
    },
    // 表格勾选
    select(rows) {
      this.$emit("update:select", rows);
    },
    selectionChange(row) {
      this.$emit("selectionChange", row);
    },
    // 全选
    selectAll(rows) {
      console.log("全选", rows);
      // this.allCheck = !this.allCheck;
      // console.log(this.allCheck);
      this.$emit("update:select", rows);
      // this.$emit("update:select", { rows, allCheck: this.allCheck });
    },

    handleCurrentChange(val) {
      console.log("handleCurrentChange", val);
      this.$emit("update:pagination", { ...this.pagination, page: val });
    },
    handleSizeChange(val) {
      console.log("handleSizeChange", val);
      if (val) {
        this.$emit("update:pagination", { ...this.pagination, rows: val });
      } else {
        //不分页
        this.$emit("update:pagination", { ...this.pagination, rows: -1 });
      }
    },
    changeSort(val) {
      // console.log(val);
    },
    renderHeader(h, obj) {
      return h("span", { class: "ces-table-require" }, obj.column.label);
    },
    handleResize() {
      // this.$nextTick(() => {
      // 	this.$refs.cesTable.doLayout()
      // })
    }
  },
  // destroyed() {
  // 	window.removeEventListener('resize', this.handleResize)
  // },
  mounted() {
    // this.handleResize()
    // window.addEventListener('resize', this.handleResize)

    var erd = elementResizeDetectorMaker();
    let _this = this;

    this.$nextTick(() => {
      this.maxHeight = document.body.offsetHeight - 280;
      erd.listenTo(this.$refs.cesTable.$refs.bodyWrapper.firstChild, function(
        element
      ) {
        if (
          element.clientWidth >
            _this.$refs.cesTable.$refs.bodyWrapper.clientWidth &&
          _this.$refs.cesTable.$refs.rightFixedWrapper
        ) {
          _this.$refs.cesTable.$refs.rightFixedWrapper.style.bottom = "10px";
        }
        if (
          element.clientHeight >= _this.maxHeight &&
          _this.$refs.cesTable.$refs.rightFixedWrapper
        ) {
          _this.$refs.cesTable.$refs.rightFixedWrapper.style.right = "10px";
        } else {
          _this.$refs.cesTable.$refs.rightFixedWrapper
            ? (_this.$refs.cesTable.$refs.rightFixedWrapper.style.right = "0")
            : null;
        }
      });
    });
  }
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.ces-pagination
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #007ae1;
  border-radius: 50%;
  /* border:2px solid #cccccc; */
  color: #fff;
  box-shadow: 0 0 0 0.05rem rgba(0, 122, 225, 0.15);
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: none;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ebedf5;
  border-radius: 5px;
}

.ces-table .el-table__fixed-body-wrapper {
  height: calc(100% - 43px) !important;
}
.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}
.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #fff;
}
.el-table__row.edit-row {
  height: 50px;
  background-color: #fffafa;
}
.el-table .redClass {
  color: red;
}
</style>
<style lang="scss" scoped>
.ces-table-require::before {
  content: "*";
  color: red;
}
.operation {
  cursor: pointer;
  padding: 0 5px;
}
.ces-pagination {
  margin-top: 20px;
}
.ces-table-page {
  margin-left: 20px;
}
.operation.green {
  color: #95d1a3;
}
.operation.red {
  color: #ff0000;
}
.operation.blue {
  color: #409eff;
}
.operation.orange {
  color: #f56c6c;
}
.operation.btnGrey {
  color: #cccccc;
}
/* 表格内图片列缩略图 */
.table-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}
.edit-input {
  display: none;
}
.edit-col .edit-input {
  display: block;
}
.edit-col .read {
  display: none;
}
.redClass {
  color: red;
  background: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tablePage.vue